export { resolvePromptDocument } from "@poe-code/config-extends";
export type {
  PromptDocumentBaseDocument,
  PromptDocumentFileSystem,
  ResolvedPromptDocument,
  ResolvePromptDocumentInput
} from "@poe-code/config-extends";
